export function getAppConfigSetting(key: string, defaultValue?: string) {
  // @ts-ignore
  const config = typeof window !== "undefined" ? window.appConfig || {} : {};
  let value;
  if (key in config) {
    //config keys are allowed to have mustache template values referencing APP_CONFIG
    value = config[key];
  }
  return value === undefined ? defaultValue : value;
}
